import React, { Fragment } from 'react';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import B2BApplicationsTable from './B2BApplicationsTable';

const Business = () => {
  return (
    <Fragment>
      <Container fluid={true} style={{ paddingTop: '30px' }}>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody style={{ padding: '15px' }}>
                <B2BApplicationsTable />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default Business;